/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserQuestionStatusSendOrderOneOf2
 */
export interface UserQuestionStatusSendOrderOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf2
     */
    status: UserQuestionStatusSendOrderOneOf2StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf2
     */
    respondedDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf2
     */
    memoryId: string;
}


/**
 * @export
 */
export const UserQuestionStatusSendOrderOneOf2StatusEnum = {
    Responded: 'RESPONDED'
} as const;
export type UserQuestionStatusSendOrderOneOf2StatusEnum = typeof UserQuestionStatusSendOrderOneOf2StatusEnum[keyof typeof UserQuestionStatusSendOrderOneOf2StatusEnum];


/**
 * Check if a given object implements the UserQuestionStatusSendOrderOneOf2 interface.
 */
export function instanceOfUserQuestionStatusSendOrderOneOf2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "respondedDateTime" in value;
    isInstance = isInstance && "memoryId" in value;

    return isInstance;
}

export function UserQuestionStatusSendOrderOneOf2FromJSON(json: any): UserQuestionStatusSendOrderOneOf2 {
    return UserQuestionStatusSendOrderOneOf2FromJSONTyped(json, false);
}

export function UserQuestionStatusSendOrderOneOf2FromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQuestionStatusSendOrderOneOf2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'respondedDateTime': json['respondedDateTime'],
        'memoryId': json['memoryId'],
    };
}

export function UserQuestionStatusSendOrderOneOf2ToJSON(value?: UserQuestionStatusSendOrderOneOf2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'respondedDateTime': value.respondedDateTime,
        'memoryId': value.memoryId,
    };
}

